import { Check, Circle } from "lucide-react";
import { cn } from "@/lib/utils";

const STEPS = ["Pré-análise inicial", "Contratação", "Conferência", "Execução", "Revisão", "Entrega"];

export function ServiceJourney({ current }: { current: number }) {
  return <ol aria-label="Etapas do processo" className="grid grid-cols-2 gap-x-4 gap-y-3 border-y border-slate-200 py-4 sm:grid-cols-3 xl:grid-cols-6">
    {STEPS.map((step, index) => <li key={step} aria-current={index === current ? "step" : undefined} className={cn("flex min-w-0 items-center gap-2 text-sm", index === current ? "font-semibold text-primary" : "text-slate-600")}>
      {index < current ? <Check aria-hidden="true" className="h-4 w-4 shrink-0 text-emerald-700" /> : <Circle aria-hidden="true" className={cn("h-4 w-4 shrink-0", index === current && "fill-primary/10")} />}
      <span>{step}</span>
    </li>)}
  </ol>;
}

export function journeyStep(status: string): number {
  if (["rascunho", "solicitado"].includes(status)) return 1;
  if (["aguardando_documentos", "em_pre_analise", "pendencia"].includes(status)) return 2;
  if (["apto_para_execucao", "em_execucao"].includes(status)) return 3;
  if (status === "em_revisao") return 4;
  return 5;
}
